<template>
  <div class="home_case">

    <LayoutTopComponent></LayoutTopComponent>

    <div class="case_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in caseImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>

      <div class="case_top_container">
        <div class="container_a"></div>
        <div class="container_b">NEWS:</div>
        <div class="container_c">最新项目垃圾回收柜</div>
      </div>
    </div>

    <div class="case_center">
      <div class="case_center_top">
        <div class="top_a">PROJECT CASE</div>
        <div class="top_b">项目案例</div>
        <div class="top_c">
          <img src="../assets/images/case_center_001.png">
        </div>
        <div class="top_d">全国多个城市均有我司产品投放实例，对不同区域和政府要求，拥有相对应款式，产品多次引起媒体关注热点并报道。</div>
      </div>
      <div class="case_center_bottom"></div>

    </div>

    <div class="case_bottom">
      <div class="case_bottom_container">
        <div class="case_bottom_body">
          <div v-for="(item,index) in caseBottomList" :key="index" class="case_bottom_item">
            <div class="case_bottom_item_image">
              <img :src="item.url">
            </div>
            <div class="case_bottom_item_text">
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="case_bottom_news">
      <div class="news_a">NEWS INFORMATION</div>
      <div class="news_b">新闻资讯</div>
      <div class="news_c">
        <img src="../assets/images/case_center_001.png">
      </div>
      <div class="news_d">
        <div style="margin-right: 12px">
          <img src="../assets/images/case_bottom_news_001.png">
        </div>
        <div class="news_d_content">
          <div class="news_d_content_a">
            <div class="news_d_content_a_left">公司新闻</div>
            <div class="news_d_content_a_right">MORE</div>
          </div>
          <div class="news_d_content_b">#实测北京刷脸分类垃圾桶#</div>
          <div class="news_d_content_c">2020-07-22</div>
          <div class="news_d_content_d">北京西城区德胜街道新风街一号院，最近因推出“人脸识别”智能垃圾桶 走红。 居民完成注册后，在投放垃圾时，垃圾桶将自动“刷脸”识别身份，打开
            桶盖，并为垃圾称重积分。
          </div>
        </div>
      </div>
      <div class="news_e">
        <div class="news_e_item">
          <div class="news_e_item_a">
            <div class="news_e_item_a_left">公司新闻</div>
            <div class="news_e_item_a_right">MORE</div>
          </div>
          <div class="news_e_item_b">杭州富从智能技术有限公司</div>
          <div class="news_e_item_c">2020-07-22</div>
          <div class="news_e_item_d">案例新闻</div>
        </div>
        <div class="news_e_item">
          <div class="news_e_item_a">
            <div class="news_e_item_a_left">生产新闻</div>
            <div class="news_e_item_a_right">MORE</div>
          </div>
          <div class="news_e_item_b">杭州富从智能技术有限公司</div>
          <div class="news_e_item_c">2021-03-02</div>
          <div class="news_e_item_d">案例新闻</div>
        </div>
        <div class="news_e_item">
          <div class="news_e_item_a">
            <div class="news_e_item_a_left">公司新闻</div>
            <div class="news_e_item_a_right">MORE</div>
          </div>
          <div class="news_e_item_b">杭州富从智能技术有限公司</div>
          <div class="news_e_item_c">2020-07-22</div>
          <div class="news_e_item_d">案例新闻</div>
        </div>
      </div>
    </div>

    <LayoutBottomComponent></LayoutBottomComponent>

  </div>
</template>


<script>

import LayoutTopComponent from '../components/LayoutTopComponent'
import LayoutBottomComponent from '../components/LayoutBottomComponent'

export default {

  data() {
    return {
      pagesHeight: '',
      caseImgList: [
        {
          url: require("../assets/images/case_top_001.png")
        },
        {
          url: require("../assets/images/case_top_001.png")
        },
        {
          url: require("../assets/images/case_top_001.png")
        }
      ],
      caseBottomList: [
        {
          url: require("../assets/images/case_bottom_001.png"),
          name: "智能回收柜+积分兑换机案例"
        },
        {
          url: require("../assets/images/case_bottom_002.png"),
          name: "智能垃圾房案例"
        },
        {
          url: require("../assets/images/case_bottom_003.png"),
          name: "智能分类垃圾箱+积分兑换机案例"
        },
        {
          url: require("../assets/images/case_bottom_004.png"),
          name: "垃圾两分类箱案例"
        },
        {
          url: require("../assets/images/case_bottom_005.png"),
          name: "智能收集秤案例"
        },
        {
          url: require("../assets/images/case_bottom_006.png"),
          name: "学校电子班牌案例"
        },
        {
          url: require("../assets/images/case_bottom_007.png"),
          name: "评价设备案例"
        },
        {
          url: require("../assets/images/case_bottom_008.png"),
          name: "学校不锈钢闸机（带人脸识别）案例"
        },
        {
          url: require("../assets/images/case_bottom_009.png"),
          name: "校彩色闸机案例"
        },
      ]
    }
  },
  components: {
    LayoutTopComponent,
    LayoutBottomComponent
  },
  mounted() {
    this.pagesHeight = this.$refs.pagesRef.clientHeight;
  },
  methods: {}

}
</script>

<style lang="less" scoped>

@import "../assets/css/common";

@media screen and (max-width: 1280px) {
  .home_case {
    width: @screenWidth1280;
    margin-top: @layoutTopHight1280;
    // 首页轮播图
    .case_top {
      height: @viewPager1280;

      .imgCls {
        width: 100%;
        height: @viewPager1280;
      }

      .case_top_container{
        bottom: -66px;
      }
    }

    .case_bottom_body{
      margin: 0 120px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {
  .home_case {
    width: @screenWidth1440;
    margin-top: @layoutTopHight1440;
    // 首页轮播图
    .case_top {
      height: @viewPager1440;

      .imgCls {
        width: 100%;
        height: @viewPager1440;
      }

      .case_top_container{
        bottom: -66px;
      }
    }

    .case_bottom_body{
      margin: 0 150px;
    }

  }
}

@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .home_case {
    width: @screenWidth1920;
    margin-top: @layoutTopHight1920;
    // 首页轮播图
    .case_top {
      height: @viewPager1920;

      .imgCls {
        width: 100%;
        height: @viewPager1920;
      }

      .case_top_container{
        bottom: -42px;
      }
    }

    .case_bottom_body{
      margin: 0 150px;
      cursor: default;
    }

  }
}

.home_case {
  display: flex;
  flex-direction: column;

  .case_top {
    position: relative;

    .case_top_container {
      background: #ffffff;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 1220px;
      height: 125px;
      box-shadow: 0px 0px 10px #333333;
      z-index: 999;

      .container_a {
        margin-left: 23px;
        width: 23px;
        height: 25px;
        background: url("../assets/images/case_top_002.png");
      }

      .container_b {
        margin-left: 5px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 43px;
      }

      .container_c {
        margin-left: 5px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #999999;
        line-height: 28px;
      }

    }
  }

  .case_center {
    background: #fefefe;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .case_center_top {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .top_a {
        margin-top: 80px;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #7F7F7F;
        line-height: 24px;
      }

      .top_b {
        margin-top: 20px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #F29C30;
        line-height: 24px;
      }

      .top_c {
        margin-top: 40px;
      }

      .top_d {
        width: 607px;
        height: 38px;
        margin: 40px 0px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

    }

    .case_center_bottom {
    }

  }

  .case_bottom {
    display: flex;
    margin-bottom: 84px;

    .case_bottom_container {
      display: flex;
      width: 100%;
      flex-direction: column;

      .case_bottom_body {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .case_bottom_item {
          display: flex;
          flex-direction: column;
          width: 512px;
          height: 426px;
          margin-top: 38px;

          .case_bottom_item_image {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .case_bottom_item_text {
            color: #ffffff;
            margin-top: -64px;
            margin-bottom: 12px;
            font-size: 28px;
            font-family: SourceHanSansCN-Medium;
          }
        }
      }


    }
  }

  .case_bottom_news {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .news_a {
      margin-top: 65px;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #7F7F7F;
      line-height: 24px;
    }

    .news_b {
      margin-top: 18px;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F29C30;
      line-height: 24px;
    }

    .news_c {
      margin-top: 18px;
    }

    .news_d {
      margin-top: 18px;
      display: flex;

      .news_d_content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        background: #F6F6F6;
        width: 560px;
        height: 300px;
        margin: 0 12px;
        padding: 0 12px;

        .news_d_content_a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .news_d_content_a_left {
            margin-top: 12px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 24px;
          }

          .news_d_content_a_right {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }

        .news_d_content_b {
          margin-top: 66px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 24px;
        }

        .news_d_content_c {
          margin-top: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 24px;
        }

        .news_d_content_d {
          text-align: left;
          margin-top: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }

      }

    }

    .news_e {
      display: flex;
      justify-content: space-between;

      .news_e_item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 12px;
        padding-left: 12px;
        width: 380px;
        height: 200px;
        background: #F6F6F6;

        .news_e_item_a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .news_e_item_a_left {
            margin: 16px 0 0 0;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 24px;
          }

          .news_e_item_a_right {
            margin: 16px 16px 0 0;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }

        .news_e_item_b {
          margin-top: 16px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 24px;
        }

        .news_e_item_c {
          margin-top: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 24px;
        }

        .news_e_item_d {
          margin-top: 22px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }

      }
    }
  }
}

</style>

